export function triggerSuspense(): never {
    /**
     * Don't need to resolve, use this when you want to suspend until the next time the component
     * renders.
     */
    throw new Promise(() => {});
}
